export const noUserSelectedError = 'The user has not been selected';
